import { makeAutoObservable } from 'mobx';

const EASY_MODE_STORAGE_KEY = 'easyModeProgress';

class StepperStore {
    currentStep = 1;
    completedSteps = [];
    animation = true;

    constructor() {
        makeAutoObservable(this);
        this.loadFromStorage();
    }

    // Загрузка состояния из localStorage
    loadFromStorage() {
        try {
            const savedState = localStorage.getItem(EASY_MODE_STORAGE_KEY);
            if (savedState) {
                const parsedState = JSON.parse(savedState);
                this.currentStep = parsedState.currentStep || 1;
                this.completedSteps = parsedState.completedSteps || [];
                this.animation = parsedState.animation !== undefined ? parsedState.animation : true;
            }
        } catch (error) {
            console.error('Error loading Easy Mode progress from localStorage:', error);
            // В случае ошибки используем значения по умолчанию
            this.currentStep = 1;
            this.completedSteps = [];
            this.animation = true;
        }
    }

    // Сохранение состояния в localStorage
    saveToStorage() {
        try {
            const stateToSave = {
                currentStep: this.currentStep,
                completedSteps: this.completedSteps,
                animation: this.animation
            };
            localStorage.setItem(EASY_MODE_STORAGE_KEY, JSON.stringify(stateToSave));
        } catch (error) {
            console.error('Error saving Easy Mode progress to localStorage:', error);
        }
    }

    setCurrentStep(step) {
        if (this.canSwitchToStep(step)) {
            this.currentStep = step;
            this.saveToStorage();
        }
    }

    canSwitchToStep(step) {
        if (this.completedSteps.includes(step)) {
            return true;
        }
        
        const maxCompletedStep = Math.max(0, ...this.completedSteps);
        return step === maxCompletedStep + 1;
    }

    completeStep(step) {
        if (!this.completedSteps.includes(step)) {
            this.completedSteps.push(step);
            this.saveToStorage();
        }
    }

    isStepCompleted(step) {
        return this.completedSteps.includes(step);
    }

    setAnimation(state) {
        this.animation = state;
        this.saveToStorage();
    }

    reset() {
        this.currentStep = 1;
        this.completedSteps = [];
        this.animation = true;
        this.saveToStorage();
    }

    // Метод для очистки прогресса (например, при выходе из аккаунта)
    clearProgress() {
        localStorage.removeItem(EASY_MODE_STORAGE_KEY);
        this.reset();
    }

    // Метод для получения прогресса в процентах
    getProgressPercentage() {
        const totalSteps = 3; // Easy Mode имеет 3 шага
        return Math.round((this.completedSteps.length / totalSteps) * 100);
    }

    // Метод для проверки, завершен ли весь процесс
    isAllStepsCompleted() {
        return this.completedSteps.length >= 3;
    }
}

export default new StepperStore(); 